"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Drawer = exports.DRAWER_ANIMATION_DURATION = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactTransitionState = require("react-transition-state");
var _ButtonIcon = require("b2b-components/theme/components/ButtonIcon");
var _classnames = _interopRequireDefault(require("classnames"));
var _Content = require("./Content/Content");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
//it should be the same as $cds-Drawer-Animation-Duration in Drawer.scss
const DRAWER_ANIMATION_DURATION = exports.DRAWER_ANIMATION_DURATION = 250;
const Drawer = _ref => {
  let {
    className,
    content,
    onOpenDrawer
  } = _ref;
  const drawerRef = (0, _react.useRef)(null);
  const closeButtonRef = (0, _react.useRef)(null);
  const [{
    status,
    isMounted
  }, toggle] = (0, _reactTransitionState.useTransition)({
    timeout: DRAWER_ANIMATION_DURATION,
    mountOnEnter: true,
    unmountOnExit: true,
    preEnter: true
  });
  const [isStateOpen, setIsStateOpen] = (0, _react.useState)(false);
  const handleOpen = event => {
    event?.preventDefault();
    setIsStateOpen(true);
    onOpenDrawer?.();
  };
  const handleClose = event => {
    event?.preventDefault();
    setIsStateOpen(false);
  };
  const handleKeyDown = event => {
    if (event.key === 'Escape' || event.key === 'Esc') {
      setIsStateOpen(false);
    }
  };
  const handleClickAway = event => {
    if (drawerRef.current?.contains(event.target)) {
      return;
    }
    setIsStateOpen(false);
  };
  (0, _react.useEffect)(() => {
    if (isStateOpen !== undefined) {
      toggle(!!isStateOpen); // it's important to cast it to boolean
    }
  }, [isStateOpen, toggle]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ButtonIcon.ButtonIcon, {
    onClick: handleOpen,
    className: "cds-Header-MenuButton cds-Drawer-Trigger",
    styleType: _ButtonIcon.BUTTON_ICON_STYLE_TYPE.blank,
    icon: _ButtonIcon.BUTTON_ICON_ICON_NAME.menu
  }), isMounted && /*#__PURE__*/_react.default.createElement(_Content.Content, {
    className: className,
    closeButtonRef: closeButtonRef,
    content: content(handleClose),
    drawerRef: drawerRef,
    onClickAway: handleClickAway,
    onClose: handleClose,
    onKeyDown: handleKeyDown,
    transitionClassName: (0, _classnames.default)({
      ['cds-Drawer-Animation--SlideLeft']: ['entering', 'preEnter'].includes(status),
      ['cds-Drawer-Animation--Close']: status === 'exiting'
    })
  }));
};
exports.Drawer = Drawer;
//# sourceMappingURL=Drawer.js.map